'use client'

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useAuth } from './useAuth'
import {
  getUserMediaHistory,
  upsertUserMediaHistory,
  type MediaHistoryInput
} from '@/lib/media-history'

export function useMediaHistory(provider?: 'youtube') {
  const { user } = useAuth()

  return useQuery({
    queryKey: ['media-history', user?.id, provider ?? 'all'],
    queryFn: () => getUserMediaHistory(provider),
    enabled: Boolean(user?.id),
    staleTime: 1000 * 60 * 5
  })
}

export function useUpsertMediaHistory() {
  const { user } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (input: MediaHistoryInput) => {
      if (!user?.id) throw new Error('User not logged in')
      return upsertUserMediaHistory(user.id, input)
    },
    onSuccess: (item) => {
      queryClient.invalidateQueries({
        queryKey: ['media-history', item.user_id]
      })
    }
  })
}
